import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ClientDetails" }
const _hoisted_2 = { class: "ClientDetails__name" }

import InnSection from "@/components/general/Section.vue";
import InnInput from "@/components/ds/input/Input.vue";
import IconButton from "@/components/ds/icon-button/IconButton.vue";
import InnForm from "@/components/ds/form/Form.vue";
import { PropType, computed } from "vue";
import { Client } from "@/types";
import commonTools from "@/tools/common-tools";
import { clientToSlug } from "@/tools/client";
import { useUiStore } from "@/stores/ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDetails',
  props: {
    client: {
        type: Object as PropType<Client>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const copySlug = () => {
    commonTools.clipboard(slug.value);
    uiStore.message("Gekopieerd...");
};

const slug = computed(() => {
    if (props.client) {
        return clientToSlug(props.client, -1);
    } else {
        return "";
    }
});

const config = {
    sections: [
        {
            items: [
                {
                    type: "text",
                    key: "vat",
                    label: "BTW nummer",
                },
            ],
        },
        {
            items: [
                {
                    type: "number",
                    key: "rate",
                    label: "Tarief",
                },
            ],
        },
        {
            items: [
                {
                    type: "text",
                    key: "contactPerson",
                    label: "Contactpersoon",
                },
                {
                    type: "text",
                    key: "salutation",
                    label: "Aanhef (incl naam)",
                },
                {
                    type: "text",
                    key: "street",
                    label: "Straat",
                },
                {
                    type: "text",
                    key: "zipcode",
                    label: "Postcode",
                },
                {
                    type: "text",
                    key: "city",
                    label: "Plaats",
                },
            ],
        },
        {
            items: [
                {
                    type: "text",
                    key: "telephone",
                    label: "Telefoon",
                },
                {
                    type: "text",
                    key: "email",
                    label: "Email",
                },
                {
                    type: "text",
                    key: "web",
                    label: "www",
                },
            ],
        },
    ],
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(InnSection, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(InnInput, {
            modelValue: __props.client.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.client.name) = $event)),
            placeholder: "Naam"
          }, null, 8, ["modelValue"]),
          _createVNode(IconButton, {
            onClick: copySlug,
            "icon-id": "paperclip"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Kopieer slug: " + _toDisplayString(slug.value), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(InnForm, {
      config: config,
      value: __props.client
    }, null, 8, ["value"])
  ]))
}
}

})